// Auth
export const urlRefreshToken = 'auth/refresh-token';
export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
  verifyCode: 'auth/verify-code',
  resendCode: 'auth/resend-code',
  forgotPassword: 'auth/forgot-password',
  createNewPassword: 'auth/new-password',
};

// Customer
export const urlApiCustomer = {
  getCustomerList: 'customers',
  createCustomer: 'customers/new',
  editCustomer: (customerId: string) => `customers/${customerId}`,
  getCustomerDetail: (customerId: string) => `customers/${customerId}`,
  importCustomer: 'customers/import',
  exportCustomer: 'customers/export-data',
  sendToQuickBooks: (customerId: string) => `customers/${customerId}/send-to-quick-books`,
  getListSchedule: (customerId: string) => `customers/${customerId}/schedule`,
  deleteCustomer: `customers`,
};

// Job
export const urlApiJob = {
  createJob: 'jobs/new',
  getJobList: 'jobs',
  getJobDetail: (jobId: string) => `jobs/${jobId}`,
  getJobDetailUpdate: (jobId: string) => `jobs/${jobId}/detail-update`,
  getJobListByCustomer: (customerId: string) => `jobs/client/${customerId}`,
  deleteJob: 'jobs',
  updateJob: (jobId: string) => `jobs/${jobId}`,
  changeStatus: (jobId: string) => `jobs/${jobId}/change-status`,
  getListSchedule: (jobId: string) => `jobs/${jobId}/schedule`,
};

// Employee
export const urlApiEmployee = {
  getEmployeeList: 'employees',
  deleteEmployee: 'employees',
  createEmployee: 'employees/new',
  uploadFileExcel: 'employees/migration-data',
  getEmployeeDetail: (employeeId: string) => `employees/${employeeId}`,
  updateEmployee: (employeeId: string) => `employees/${employeeId}`,
  updateEmployeeStatus: (employeeId: string) => `employees/${employeeId}/change-status`,
  getEmployeeReview: (token: string) => `employees/review/${token}`,
};

// Folder
export const urlApiFolder = {
  getFolderList: 'folders',
  createFolder: 'folders/new',
  editFolder: (folderId: string) => `folders/${folderId}`,
  deleteFolder: (folderId: string) => `folders/${folderId}`,
};

// File
export const urlApiFile = {
  uploadMultipleFileAndGetLink: 'file/upload-multiple-files',
  getListFile: 'file',
};

// Document
export const urlApiDocument = {
  uploadDocument: (folderId: string) => `file/folders/${folderId}`,
  getDocumentList: (folderId: string) => `file/folders/${folderId}`,
  editDocument: (fileId: string) => `file/${fileId}`,
  deleteDocument: (fileId: string) => `file/${fileId}`,
};

// Contact
export const urlApiContact = {
  createContact: 'contacts/new',
  getContactList: 'contacts',
  deleteContact: 'contacts',
  getContactDetail: (contactId: string) => `contacts/${contactId}`,
  updateContact: (contactId: string) => `contacts/${contactId}`,
  sendEmail: (contactId: string) => `contacts/${contactId}/send-email`,
  convertToCustomer: (contactId: string) => `contacts/${contactId}/convert-customers`,
};

// Schedule
export const urlApiSchedule = {
  createSchedule: 'schedules/new',
  getScheduleList: 'schedules',
  getScheduleDashboardList: 'schedules/dashboard',
  deleteSchedule: (scheduleId: string) => `schedules/${scheduleId}`,
  getScheduleDetail: (scheduleId: string) => `schedules/${scheduleId}`,
  updateSchedule: (scheduleId: string) => `schedules/${scheduleId}`,
};

// Notes
export const urlApiNotes = {
  createNoteSchedule: 'notes/new',
  getNoteScheduleList: 'notes',
  getListNote: 'notes',
  createNote: 'notes/new',
  updateNote: (noteId: string) => `notes/${noteId}`,
  deleteNote: (noteId: string) => `notes/${noteId}`,
};

// Activity
export const urlApiActivity = {
  getActivityList: 'activities',
};

// User
export const urlApiUser = {
  getProfile: 'users/profile',
  updateProfile: 'users/profile',
  changePassword: 'users/change-password',
};

// Task
export const urlApiTask = {
  createTask: 'tasks/new',
  getTaskList: 'tasks',
  deleteTask: (taskId: string) => `tasks/${taskId}`,
  getTaskDetail: (taskId: string) => `tasks/${taskId}`,
  updateTask: (taskId: string) => `tasks/${taskId}`,
  changeStatusTask: (taskId: string) => `tasks/${taskId}/status`,
  createTaskJob: (jobId: string) => `tasks/job/${jobId}`,
};

// Service
export const urlApiService = {
  getServiceList: 'services',
  createService: 'services/new',
  getServiceDetail: (serviceId: string) => `services/${serviceId}`,
  updateService: (serviceId: string) => `services/${serviceId}`,
  deleteService: (serviceId: string) => `services/${serviceId}`,
};

// Material
export const urlApiMaterial = {
  getMaterialList: 'materials',
  deleteMaterial: (materialId: string) => `materials/${materialId}`,
  createMaterial: 'materials/new',
  getMaterialDetail: (materialId: string) => `materials/${materialId}`,
  updateMaterial: (materialId: string) => `materials/${materialId}`,
};

// Price Book
export const urlApiPriceBook = {
  getPriceBookList: 'price-books',
  createPriceBook: 'price-books/new',
  getPriceBookDetail: (priceBookId: string) => `price-books/${priceBookId}`,
  updatePriceBook: (priceBookId: string) => `price-books/${priceBookId}`,
  deletePriceBook: (priceBookId: string) => `price-books/${priceBookId}`,
};

// Statistic
export const urlApiStatistic = {
  getTotalStatistic: 'statistics/summary',
};

// Conversation
export const urlApiConversation = {
  getListConversation: 'conversations',
  createNewMessage: (conversationId: string) => `conversations/${conversationId}/messages/new`,
  createNewConversation: 'conversations/new',
  getListMessage: (conversationId: string) => `conversations/${conversationId}/messages`,
};

// Estimate Template
export const urlApiEstimateTemplate = {
  getEstimateTemplateList: 'estimates/templates',
  createEstimateTemplate: 'estimates/templates/new',
  deleteEstimateTemplate: (estimateTemplateId: string) => `estimates/${estimateTemplateId}`,
  updateEstimateTemplate: (estimateTemplateId: string) => `estimates/templates/${estimateTemplateId}`,
  getEstimateTemplateDetails: (estimateTemplateId: string) => `estimates/templates/${estimateTemplateId}`,
};

// Campaign
export const urlApiCampaign = {
  getListCampaign: 'campaigns',
  createCampaign: 'campaigns/new',
  deleteCampaign: (campaignId: string) => `campaigns/${campaignId}`,
  getDetailCampaign: (campaignId: string) => `campaigns/${campaignId}`,
  updateCampaign: (campaignId: string) => `campaigns/${campaignId}`,
};

// Estimate
export const urlApiEstimate = {
  createEstimate: 'estimates/new',
  getListEstimate: 'estimates',
  deleteEstimate: (estimateId: string) => `estimates/${estimateId}`,
  getEstimateDetail: (estimateId: string) => `estimates/${estimateId}`,
  updateEstimate: (estimateId: string) => `estimates/${estimateId}`,
  getEstimateDetailUpdate: (estimateId: string) => `estimates/${estimateId}/detail-update`,
  convertToJob: (estimateId: string) => `estimates/${estimateId}/convert-to-job`,
  sendEstimate: (estimateId: string) => `estimates/send-estimate/${estimateId}`,
  changeStatus: (estimateId: string) => `estimates/${estimateId}/change-status`,
};

// Time Clock
export const urlApiTimeClock = {
  getListTimeClock: 'time-clocks',
  deleteTimeClock: (timeClockId: string) => `time-clocks/${timeClockId}`,
  getTimeClockDetails: (timeClockId: string) => `time-clocks/${timeClockId}`,
  exportTimeClocks: 'time-clocks/export-hours-worked',
  getTimeClockHoursWorked: 'time-clocks/hours-worked',
};

// Notification
export const urlApiNotification = {
  getListNotification: 'notifications',
  readNotification: (notificationId: string) => `notifications/${notificationId}/read`,
};

// Category
export const urlApiCategory = {
  getListCategory: 'master-data',
};

// Master Data
export const urlApiMasterData = {
  getListMasterData: 'master-data',
};

// Invoice
export const urlApiInvoice = {
  getInvoiceList: 'invoices',
  getInvoiceDetails: (invoiceId: string) => `invoices/${invoiceId}`,
  changeStatusInvoice: (invoiceId: string) => `invoices/${invoiceId}/change-status`,
  sendInvoice: (invoiceId: string) => `invoices/${invoiceId}/send-invoice`,
};

// QuickBooks
export const urlApiQuickBooks = {
  getListCustomerQuickBooks: 'quick-books/customers',
  getAuthUrl: 'quick-books/auth-url',
  disconnect: 'quick-books/disconnect',
};

// Review
export const urlApiReview = {
  getReview: 'reviews',
  createReview: 'reviews/new',
  createReply: 'reviews/reply',
};

// Report
export const urlApiReport = {
  getServiceVolume: 'reports/service-volume',
  getAverageJob: 'reports/per-call-average',
  getPurchaseOderTotal: 'reports/purchase-order-total-per-pay-period',
  getSaleByCity: 'reports/sales-by-city',
  getJobDistribution: 'reports/technician/job-distribution',
};

// PO
export const urlApiPO = {
  getPOList: `purchase-orders`,
  deletePO: (poId: string) => `purchase-orders/${poId}`,
  getPONumber: 'purchase-orders/po-number',
  createPO: 'purchase-orders/new',
  editPO: (poId: string) => `purchase-orders/${poId}`,
};

// Vendor
export const urlApiVendor = {
  getVendorList: 'vendors',
};

// Google
export const urlApiGoogle = {
  getAuthUrl: 'googles/auth-url',
  getToken: (code: string) => `googles/review-callback?code=${code}`,
  connect: `googles/connect`,
  disconnect: 'googles/disconnect',
  getListGmail: 'googles',
  sendGoogleGmail: 'googles/send-message',
};
